import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Utils } from "@serasa/shared/utils/utils";

import { environment } from "../../../../../environments/environment";
import {
  BlockUserPayload,
  UnblockUserPayload,
} from "../interfaces/dashboard-state.interface";
@Injectable({ providedIn: "root" })
export class DashboardService {

  constructor(
    private readonly _http: HttpClient
  ) { }

  public blockUser(payload: BlockUserPayload) {
    const defaultHeader = Utils.generateDefaultHeader();
    const headers = defaultHeader.append('Invalidate-Cache', 'true');

    return this._http.post(
      `${environment.logonPortalBaseUrl}/user-accounts/locking-by-agent`,
      payload,
      {
        headers,
      },
    );
  }

  public deleteUser(logon: string) {
    const defaultHeader = Utils.generateDefaultHeader();
    const headers = defaultHeader.append('Invalidate-Cache', 'true');

    return this._http.delete(
      `${environment.logonPortalBaseUrl}/my-logons/${logon}`,
      {
        headers,
      },
    );
  }

  public unblockUser(payload: UnblockUserPayload) {
    const defaultHeader = Utils.generateDefaultHeader();
    const headers = defaultHeader.append('Invalidate-Cache', 'true');

    return this._http.post(
      `${environment.logonPortalBaseUrl}/user-accounts/unlocking-by-agent`,
      payload,
      {
        headers,
      },
    );
  }
  
}
